import React, { useContext } from 'react';
import {
    Box,
    TableRow,
    Typography,
    Tooltip,
    InputLabel,
    Autocomplete,
    TextField,
    Stack,
    Select,
    MenuItem
} from '@mui/material';
import InternalFundContext from '../../../component/contextfolder/InternalFundContext/InternalFundContext';
import ReportContext from '../../../component/contextfolder/ReportContext/ReportContext';
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import DataTable from '../../../custom/DataTable';
import CustomDialog from '../../../custom/CustomDialog';
import { Delete } from '@mui/icons-material';
import { StyledTableCell } from '../../../custom/StyledTableCell';

function InternalFund() {
    const { depoUserList } = useContext(ReportContext);
    const {
        chooseMember,
        setChooseMember,
        internalFormValue,
        setInternalFormValue,
        reportList,
        handleDelete,
        handleDeleteTrue,
        handleDeleteFalse,
        delPopup
    } = useContext(InternalFundContext);

    let sum = reportList.reduce(function (prev, current) {
        return prev + +current.amount;
    }, 0);

    const handleChanges = (event, newValue) => {
        setChooseMember(newValue ? newValue.memID : "");
    };

    const handleReport = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        setInternalFormValue({ ...internalFormValue, [name]: value });
    };

    const handleDate = ({ adDate }) => {
        setInternalFormValue({ ...internalFormValue, fromDate: adDate });
    };

    const handleDate1 = ({ adDate }) => {
        setInternalFormValue({ ...internalFormValue, toDate: adDate });
    };

    const columns = [
        {
            key: 'sn',
            label: 'SN',
            render: (row, index) => index + 1
        },
        {
            key: 'tranID',
            label: 'Transaction ID',
            filterType: "select"
        },
        {
            key: 'txnDate',
            label: 'Transaction Date',
            filterType: "select"
        },
        {
            key: 'senderAccountNum',
            label: 'From (Acc. No.)',
            filterType: "select"
        },
        {
            key: 'destAccountNum',
            label: 'To (Acc. No.)',
            filterType: "select"
        },
        {
            key: 'amount',
            label: 'Amount',
            filterType: "select"
        },
        {
            key: 'remarks',
            label: 'Remarks',
            filterType: "select"
        },
        {
            key: 'status',
            label: 'Status',
            filterType: "select",
            render: (row) => (
                <Tooltip title={row.status === "PENDING" ? "Click to Delete" : ""}>
                    <Typography
                        sx={{
                            color: row.status === "PENDING" ? "warning.main" :
                                row.status === "FAIL" ? "error.main" : "success.main",
                            cursor: row.status === "PENDING" ? "pointer" : "default"
                        }}
                        onClick={row.status === "PENDING" ? () => handleDelete(row.tranID) : undefined}
                    >
                        {row.status}
                    </Typography>
                </Tooltip>
            )
        }
    ];

    return (
        <>
            <DataTable
                columns={columns}
                data={reportList}
                download={{ enabled: true, filename: 'Internal Fund Report', excludeColumns: ['sn'] }}
                footer={
                    (sum > 0) &&
                    <TableRow>
                        <StyledTableCell colSpan={4} sx={{ textAlign: "right", fontWeight: "bold" }}>Total:</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: "bold" }}>{sum.toFixed(2)}</StyledTableCell>
                    </TableRow>
                }
                actions={
                    <Box sx={{
                        display: 'flex',
                        gap: 1,
                        width: '100%',
                        flexWrap: 'wrap'
                    }}>
                        <Box sx={{ minWidth: 150, mb: 2 }}>
                            <Stack spacing={0.5}>
                                <InputLabel>Member</InputLabel>
                                <Autocomplete
                                    options={[
                                        { memID: "", fullName: "All" },
                                        ...(depoUserList || [])
                                    ]}
                                    getOptionLabel={(option) => option.fullName || ""}
                                    value={
                                        chooseMember === ""
                                            ? { memID: "", fullName: "All" }
                                            : depoUserList?.find((item) => item.memID === chooseMember) || null
                                    }
                                    onChange={handleChanges}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Member"
                                            size="small"
                                        />
                                    )}
                                    fullWidth
                                    size="small"
                                    autoHighlight={true}
                                    autoComplete={true}
                                    clearOnEscape={true}
                                    noOptionsText="No members found"
                                    loadingText="Loading members..."
                                    isOptionEqualToValue={(option, value) => option.memID === value.memID}
                                    loading={depoUserList === null}
                                />
                            </Stack>
                        </Box>

                        <Box sx={{ minWidth: 150 }}>
                            <Stack spacing={0.5}>
                                <InputLabel> From Date</InputLabel>
                                <Calendar
                                    className="form-control form-control-sm mb-1"
                                    dateFormat="YYYY/MM/DD"
                                    theme="default"
                                    language="en"
                                    value={internalFormValue.fromDate}
                                    onChange={handleDate}
                                />
                            </Stack>
                        </Box>

                        <Box sx={{ minWidth: 150 }}>
                            <Stack spacing={0.5}>
                                <InputLabel> To Date</InputLabel>
                                <Calendar
                                    className="form-control form-control-sm mb-1"
                                    dateFormat="YYYY/MM/DD"
                                    theme="default"
                                    language="en"
                                    value={internalFormValue.toDate}
                                    onChange={handleDate1}
                                />
                            </Stack>
                        </Box>

                        <Box sx={{ minWidth: 150 }}>
                            <Stack spacing={0.5}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    name="status"
                                    value={internalFormValue.status || ""}
                                    onChange={handleReport}
                                    displayEmpty
                                    fullWidth
                                    size="small"
                                >
                                    <MenuItem value="" disabled>Select Status</MenuItem>
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="COMPLETED">Completed</MenuItem>
                                    <MenuItem value="PENDING">Pending</MenuItem>
                                </Select>
                            </Stack>
                        </Box>
                    </Box>
                }
            />

            <CustomDialog
                isOpen={delPopup?.show}
                title="Confirm Delete"
                message="Are you sure you want to delete?"
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={handleDeleteTrue}
                onCancel={handleDeleteFalse}
                confirmColor="error"
                cancelColor="inherit"
                icon={<Delete fontSize="small" color='error' />}
            />
        </>
    );
}

export default InternalFund;